// The auto-confirm banner states the basis in the server's plain-language label.
export const autoMatchBasisSubtitle = (basisLabel: string | null): string => {
  if (!basisLabel) return 'This party was confirmed by the auto-match gate.';
  return `This party was confirmed on ${basisLabel}.`;
};
